<template>
    <div>
        <div class="muven-card">
            <div class="muven-card-title">
                <p>
                    Pedidos não importados
                    
                    <router-link 
                        class="btn btn-outline-secondary btn-sm float-right"
                        :to="orderListWithFilter">
                        <fa icon="external-link-alt" />
                    </router-link>
                </p>
            </div>

            <div>
                <highcharts :options="pendingOrdersIntegrationBackendChartOptions" ref="chart"/>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from 'highcharts'
import { OrderStatusEnum } from '@c2b/muven-commons';
import dashboardService from '@/dashboard/services/DashboardService'
import {createGraphic} from '@/utils/normalizers/GraphicNormalizer'
import {sum} from 'lodash'
import { dangerColor } from '../constants/Color'
import { mapState } from 'vuex'

export default {
    name: 'PendingOrdersIntegrationBackendCmp',
    data() {
        return {
            orderListWithFilter: '',
            pendingList: [],
            pendingOrdersIntegrationBackendChartOptions: createGraphic({
                chart: {
                    type: 'pie',
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    margin: 0,
                    height: 300
                },
                tooltip: {
                    formatter() {
                        return `
                            ${this.point.pendingOrder.description}: <b>${this.point.pendingOrder.total}</b> pedidos
                        `   
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: false
                        },
                        showInLegend: true,
                        startAngle: -90,
                        endAngle: 90,
                        center: ['50%', '65%'],
                        size: '100%'
                    },
                },
                legend: {
                    enabled: true,
                },
                series: [
                    {
                        innerSize: '72%',
                        data: [],
                    }
                ]
            }),
        }
    },
    async mounted() {
        const orderStatusListImportsPending = [
            OrderStatusEnum.Pending,
            OrderStatusEnum.Approved,
            OrderStatusEnum.Billed,
            OrderStatusEnum.Posted,
            OrderStatusEnum.PendingMercadoLivreFull,
            OrderStatusEnum.ApprovedMercadoLivreFull,
            OrderStatusEnum.BilledMercadoLivreFull,
            OrderStatusEnum.PostedMercadoLivreFull,
            OrderStatusEnum.PendingAssignments,
            OrderStatusEnum.Error,   
        ].join(',')

        const orderStatusListDoesNotImportPending = [
            OrderStatusEnum.Approved,
            OrderStatusEnum.Billed,
            OrderStatusEnum.Posted,
            OrderStatusEnum.PendingMercadoLivreFull,
            OrderStatusEnum.ApprovedMercadoLivreFull,
            OrderStatusEnum.BilledMercadoLivreFull,
            OrderStatusEnum.PostedMercadoLivreFull,
            OrderStatusEnum.PendingAssignments,
            OrderStatusEnum.Error,   
        ].join(',')
        
        if (this.subscriber.isBackendShop() || this.subscriber.isBackendInterfacenet()) {
            this.orderListWithFilter = `/pedidos?custom=true&statusIdSource=2&statusList=${orderStatusListImportsPending}`
        } else {
            this.orderListWithFilter = `/pedidos?custom=true&statusIdSource=2&statusList=${orderStatusListDoesNotImportPending}`
        }

        this.pendingList = await dashboardService.getPendingOrdersIntegrationBackend()

        this.$refs.chart.chart.series[0].setData(this.pendingList.map((p, index) => {
            return {
                color: index === 0 ? dangerColor : Highcharts.getOptions().colors[index],
                y: p.total,
                name: p.description,
                pendingOrder: {
                    ...p,
                },
            }
        }))  

        this.$refs.chart.chart.setTitle({            
            text: `<div class="muven-donut-total">
                <span class="muven-donut-total-label">Total</span>
                <span class="muven-donut-total-value">${sum(this.pendingList.map((p) => p.total))}</span>
            </div>`,
            useHTML: true,
            align: 'center',
            verticalAlign: 'middle',
            y: 40,
        })
    },
    computed: {
        ...mapState({
            subscriber: state => state.subscriber,
        }),
    },
}
</script>
